import { render, staticRenderFns } from "./ModelConfigExportPlus.vue?vue&type=template&id=4952e0fc&scoped=true"
import script from "./ModelConfigExportPlus.vue?vue&type=script&lang=js"
export * from "./ModelConfigExportPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4952e0fc",
  null
  
)

export default component.exports